import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import axios from 'axios';

// @ts-ignore - no typing info for YML files
import carrierData from 'resources/carriers.yml';

import { makeBtStyles } from '../Theme';
import CarrierIcon from '../components/CarrierIcon';
import { Carrier } from '../dataProviders';


const useStyles = makeBtStyles( theme => ({
  root: {
    border: '1px solid #DEDEDE',
    padding: '20px',
    display: 'flex'
  },
  carrierIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '110px' // not necessary but prevents jump when icon loads late
  },
  carrierIcon: {
    width: '60px',
    marginLeft: '20px',
    marginRight: '30px'
  },
  title: {
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '19px'
  },
  text: {
    margin: '0',
    marginTop: '10px',
    fontSize: '14px',
    lineHeight: '20px',
    '&:empty': {
      display: 'none'
    }
  }
}));

export default function ReturnShippingDescriptor({ className='', onRateNoticeLoaded }:{ className: string, onRateNoticeLoaded: () => void }) {
  const classes = useStyles();
  const intl = useIntl();
  const [notice,setNotice] = useState<any>();
  const [error,setError] = useState<string|null>();

  useEffect( () => {
    axios.get('/return-cost-notice').then(
      (response) => {
        setNotice(response.data);
        onRateNoticeLoaded();
      },
      (error) => setError('There was a problem loading your return cost. Please, try again.')
    )
  }, [onRateNoticeLoaded] );

  let title, text;
  if( notice ) {
    const carrier = carrierData[notice.carrier_code]?.name || 'Carrier';
    if( notice.title && notice.text ) {
      if( notice.cost?.amount_cents === 0 ) {
        title = `Print FREE ${carrier} Return Label`;
      }
      else {
        const cost = notice.cost && parseInt(notice.cost.amount_cents)/100;
        const formattedCost = cost ? intl.formatNumber(cost , { currency: notice.cost.currency_code, style: 'currency' }) : '';
        title = notice.title.replaceAll('{cost}', formattedCost);
        text = notice.text.replaceAll('{cost}', formattedCost);
      }
    }
    else {
      title = `Print ${carrier} Return Label`;
      text = 'Returns may be subject to a fee which will be deducted from your refund amount after your return is received and processed.';
    }
  }

  return <div className={classnames(classes.root,className)}>
    { notice ? (<>
      <div className={classes.carrierIconWrapper}>
        <CarrierIcon carrier_code={notice.carrier_code as Carrier} className={classes.carrierIcon} />
      </div>
      <div>
        <div className={classes.title}>
          {title}
        </div>
        <p className={classes.text}>
          {text}
        </p>
      </div>
    </>):( error ? (<>
      {error}
    </>):(<>
      LOADING YOUR RETURN RATE
    </>))}
  </div>;
}